import {
  Box,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  TextField,
  Typography,
  Divider
} from '@mui/material';
import React from 'react';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import AttachedDocumentsTable from './attachments/AttachedDocumentsTable';
import DocumentsButtons from './DocumentsButtons';

const OlDocuments = ({ formik }) => (
  <Card>
    <CardHeader title="Dokumenty" />
    <CardContent>
      <DocumentsButtons />
      <Grid item xs={12} sm={6} md={3}>
        <FormControl fullWidth>
          <Typography variant="subtitle2">Sposób wysyłki umowy</Typography>
          <SmallFormTextField
            select
            name="way_of_sending_contract"
            placeholder="sposób wysyłki umowy"
            options={[
              { value: 'email', label: 'E-mail' },
              { value: 'traditional_mail', label: 'Poczta tradycyjna' }
            ]}
            value={formik.values.way_of_sending_contract}
            onChange={formik.handleChange}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Typography variant="subtitle2">Uwagi</Typography>
        <TextField
          fullWidth
          name="documents_notes"
          type="text"
          placeholder="Uwagi dotyczące dokumentów"
          multiline
          rows={3}
          value={formik.values.documents_notes}
          onChange={formik.handleChange}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AttachedDocumentsTable formik={formik} />
      </Grid>
      <Box height={40} />
    </CardContent>
  </Card>
);

export default OlDocuments;
